import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../../Field';

class Accountant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEmploymentPermanent: null,
        };
        this.inputComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    getChildInputComponents() {
        let inputComponents = this.inputComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        });
        return inputComponents;
    }

    /**
     * Sets whether or not the employment is permanent, calls the
     * handleEmploymentChanging method for passing back up the chain.
     *
     * @param v
     */
    handleDurationUpdate(v) {
        this.setState({ isEmploymentPermanent: v });
    }

    render() {
        let index = this.props.financialRefereeStatus - 1;

        return(
            <div>
                <Field
                    fieldName={this.props.fieldPrefix + 'AccountantFirmName'}
                    question="Name of accountancy firm we should contact for a reference"
                    storageKey="companyName"
                    type="text"
                    maxLength={60}
                    dataValidation="required_field"
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.companyName'}
                    source={this.props.source}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    fieldName={this.props.fieldPrefix + 'AccountantName'}
                    question="Accountant name"
                    storageKey="contactName"
                    type="text"
                    maxLength={60}
                    dataValidation="alpha_and_space_only"
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.contactName'}
                    source={this.props.source}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                    forcibleValidation
                />
                <Field
                    type="address"
                    fieldName={this.props.fieldPrefix + 'AccountantAddress_'}
                    question="Accountant postcode"
                    storageKey="address"
                    addressOptions={{
                        pafLookup: true,
                        canBeForeign: true,
                        hasManualEntryOption:true,
                    }}
                    source={this.props.source + '.address'}
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.address'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    fieldName={this.props.fieldPrefix + 'AccountantMobile'}
                    question="Accountant mobile (UK only)"
                    storageKey="mobile"
                    type="text"
                    helpText="Providing a mobile number for your accountant can help speed up your application."
                    dataValidation="mobile_number.non_mandatory"
                    labelExtra="Mobile number is used to send updates on the application, this must be a UK based number"
                    source={this.props.source}
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.mobile'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    type="email"
                    fieldName={this.props.fieldPrefix + 'AccountantEmail'}
                    question="Accountant email"
                    storageKey="email"
                    dataValidation="email_address.non_mandatory"
                    source={this.props.source}
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.email'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    fieldName={this.props.fieldPrefix + 'AccountantPhone'}
                    question="Accountant telephone number"
                    storageKey="phone"
                    type="text"
                    maxLength={20}
                    dataValidation="phone_number"
                    source={this.props.source}
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.phone'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'position' + index}
                    question="Is your self employment permanent or temporary?"
                    storageKey="isPermanent"
                    type="button-choice"
                    options={[
                        {
                            value: true,
                            text: 'Permanent'
                        },
                        {
                            value: false,
                            text: 'Temporary'
                        }
                    ]}
                    dataValidation="required_field"
                    source={this.props.source}
                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.isPermanent'}
                    loadValues={true}
                    callbackFunction={this.handleDurationUpdate.bind(this)}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                {this.state.isEmploymentPermanent === false ?
                    <Field
                        type="date"
                        subType="end-date"
                        fieldName={'end_date' + index}
                        storageKey="employmentEndDate"
                        question="When will your contract be ending?"
                        loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.employmentEndDate'}
                        loadValues={true}
                        dataValidation="end_date"
                        source={this.props.source}
                    />
                : null}
            </div>
        );
    }
}

Accountant.propTypes = {
    fieldPrefix:            PropTypes.string.isRequired,
    source:                 PropTypes.string.isRequired,
    financialRefereeStatus: PropTypes.number,
};

export default Accountant;


// WEBPACK FOOTER //
// ./src/components/Screens/Sections/Accountant.js